module.exports = __webpack_public_path__ + "00856c6cd25a4008b410b7ddee5df8dd.svg";